import Loadable from '../../components/loadable';
import ModalPlaceholder from '../../components/modal_placeholder';

const RecurringBookingEventsReport = Loadable({
  loader: () =>
    import('../../pages/reports/recurring_booking_events_report/recurring_booking_events_report'),
  type: 'block',
});

angular.module('gym').value('RecurringBookingEventsReport', RecurringBookingEventsReport);

const RecurringBookingEventsReportFiltersModal = Loadable({
  loader: () =>
    import(
      '../../pages/reports/recurring_booking_events_report/recurring_booking_events_report_filters_modal'
    ),
  loading: ModalPlaceholder,
});

angular
  .module('gym')
  .value('RecurringBookingEventsReportFiltersModal', RecurringBookingEventsReportFiltersModal);
